import { handleActions } from 'redux-actions';

let SET_TOOLTIP = 'gdc/SET_TOOLTIP';

export let setTooltip = Component => ({ type: SET_TOOLTIP, Component });

export default handleActions({
  [SET_TOOLTIP]: (state, { Component }) => ({ Component })
}, { Component: null });
